"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VolumeMuteIcon;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("../../SvgIcon"));

var _ref = /*#__PURE__*/_react.default.createElement("path", {
  d: "M15 0v15V0zM0 0v15V0zm7.168 13.261c.322.286.832.057.832-.374V2.113c0-.431-.51-.66-.832-.374L3.5 5h-2c-.276 0-.5.224-.5.5v4c0 .276.224.5.5.5h2l3.668 3.261zm5.18-5.761l1.223 1.223c.195.195.195.511-.001.707l-.141.14c-.195.196-.512.196-.707 0L11.5 8.348 10.278 9.57c-.195.196-.512.196-.707 0l-.141-.14c-.196-.196-.196-.512-.001-.707L10.652 7.5 9.429 6.277c-.195-.195-.195-.511.001-.707l.141-.14c.195-.196.512-.196.707 0L11.5 6.652l1.222-1.222c.195-.196.512-.196.707 0l.141.14c.196.196.196.512.001.707L12.348 7.5z",
  fillRule: "evenodd"
});

var _ref2 = /*#__PURE__*/_react.default.createElement("path", {
  d: "M20 0v20M0 0v20M19.354 7.354l-.708-.708c-.195-.195-.511-.195-.707 0L16 8.586l-1.939-1.94c-.196-.195-.512-.195-.707 0l-.708.708c-.195.195-.195.511 0 .707L14.586 10l-1.94 1.939c-.195.196-.195.512 0 .707l.708.708c.195.195.511.195.707 0L16 11.414l1.939 1.94c.196.195.512.195.707 0l.708-.708c.195-.195.195-.511 0-.707L17.414 10l1.94-1.939c.195-.196.195-.512 0-.707M8.72 16.72L5 13H2.5c-.276 0-.5-.224-.5-.5v-5c0-.276.224-.5.5-.5H5l3.72-3.72c.472-.472 1.28-.137 1.28.531v12.378c0 .668-.808 1.003-1.28.531",
  fillRule: "evenodd"
});

function VolumeMuteIcon(props) {
  return _react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
    viewBox: function viewBox(size) {
      return size < 20 ? '0 0 15 15' : '0 0 20 20';
    }
  }, props), function (size) {
    return size < 20 ? _ref : _ref2;
  });
}

VolumeMuteIcon.displayName = 'VolumeMuteIcon';